<template>
  <fieldset class="mb-4">
    <slot></slot>
  </fieldset>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "BillingAddressDetails",
  computed: {
    ...mapState(['mainConfig'])
  }
}
</script>

<style scoped>

</style>
